import React, { useEffect, useState } from 'react';
import Footer from '../../component/Footer';
import Header from '../../component/Header';
import './Cartpage.css';
import Order from '../../assets/order.jpg';
import axios from "../../helper/axios"
import { makeCartEmpty } from "../../action";
import { useDispatch, useSelector } from "react-redux";

const OrderSuccess = () => {
  const dispatch = useDispatch()
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const transId = params.get('transId');

  useEffect(() => {
    paymentStatusChange();
  }, [])

  const paymentStatusChange = async () => {
    const data = { transId: transId, status: "failed" };
    dispatch(makeCartEmpty(data));
    // await axios.post("https://appapi.albionline.com/api/updatepaymentstatus/", data);
  }



  return (
    <>
      <Header />
      <div className="order-success-page">
        <div className="card-success">
          <div style={{ borderRadius: '200px', height: '200px', width: '200px', background: '#ff0000', margin: '0 auto' }}>
            <i className="checkmark">X</i>
          </div>
          <h2 className="success-h2">Failed</h2>
          <p>Payment is not successfull<br /> Please try again</p>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default OrderSuccess;